module.exports = __webpack_public_path__ + "img/damDanger.6cf1d064.svg";